// extracted by mini-css-extract-plugin
export default {"ratingPopUp":"RatingPopUp_ratingPopUp__QWd4Y","selection":"RatingPopUp_selection__9zI3t"};